<!-- Page Content -->
<div id="page-content">
  <div class="container">
    <div class="row">
      <!--MAIN Content-->
      <div class="col-md-12">
        <header><h2 class="no-divider">{{category}}</h2 ></header>

        <div id="page-main">
          <section id="members">

            <!--CSS Loader-->
            <section *ngIf="loader">
              <h3 class="no-divider"></h3>
              <div class="row">
                <div class="col-md-6 col-sm-6" *ngFor="let x of divRepat">
                  <div class="ph-item author-block course-speaker ph-border">
                    <div class="ph-col-4">
                      <div class="ph-avatar"></div>
                    </div>
                    <article class="paragraph-wrapper">
                      <div class="ph-row inner">
                        <div class="ph-col-12 empty"></div>
                        <div class="ph-col-12 empty"></div>
                        <div class="ph-col-8"></div>
                        <div class="ph-col-6"></div>
                        <div class="ph-col-12"></div>
                        <div class="ph-col-8"></div>
                        <div class="ph-col-6"></div>
                        <div class="ph-col-4"></div>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->
              </div> <!-- /.row -->
            </section><!-- /#our-speakers -->
            <!--CSS Loader-->

            <section>
              <!--Dean Details-->
              <div class="row" *ngIf="category==='Academic'">
                <div class="col-md-6 col-sm-6" *ngFor="let dean of deanData">
                  <div class="author-block course-speaker">
                    <a routerLink="/staff/{{dean.profile_name}}">
                      <figure class="author-picture"><img src="{{dean.user.profile_image}}" alt=""></figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a routerLink="/staff/{{dean.profile_name}}">
                            {{dean.full_name}} ({{dean.title}}.)
                          </a>
                        </header>
                        <div *ngFor="let desig of dean.staff_vs_desigs">
                          <p>{{desig.staff_desig.designation}}</p>
                        </div>

                        <p>
                          <span *ngIf="dean.user.email != 'null'">
                            {{dean.user.email}}
                          </span>

                          <span *ngIf="dean.second_email != 'null'">
                            <br>{{dean.second_email}}
                          </span>

                          <span *ngIf="dean.user.mobile_number != 'null'">
                            <br>{{dean.contact}}
                          </span>
                        </p>

                        <a routerLink="/staff/{{dean.profile_name}}" type="button" class="btn-link linked-button">
                          Profile
                        </a>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->
              </div> <!-- /.row -->
            </section>

            <section id="our-staff" *ngFor="let dept of staffData">
              <!--Staff details-->
              <h3 class="no-divider" *ngIf="dept.staff.length != 0">{{dept.dept_name}}</h3>
              <div class="row">
                <div class="col-md-6 col-sm-6" *ngFor="let member of dept.staff">
                  <div class="author-block course-speaker">
                      <a routerLink="/staff/{{member.profile_name}}">
                        <figure class="author-picture">
                          <span *ngIf="member.user?.profile_image != 'null'">
                            <img src="{{member.user?.profile_image}}" alt="{{member?.profile_name}}">
                          </span>
                        </figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a routerLink="/staff/{{member.profile_name}}">
                            {{member?.full_name}} ({{member?.title}}.)
                          </a>
                        </header>
                        <div *ngFor="let desig of member.staff_vs_desigs">
                          <p>{{desig?.staff_desig.designation}}</p>
                        </div>

                        <span class="desitination-staff">{{getSpeciality(member.staff_specialties)}}</span>
                        <p>
                          <span *ngIf="member.user?.email != 'null'">
                            {{member.user?.email}}
                          </span>

                          <span *ngIf="member.second_email != 'null'">
                            <br>{{member?.second_email}}
                          </span>

                          <span *ngIf="member.contact != 'null'">
                            <br>{{member?.contact}}
                          </span>
                        </p>

                        <a routerLink="/staff/{{member.profile_name}}" type="button" class="btn-link linked-button">
                          Profile
                        </a>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->
                </div> <!-- /.row -->
            </section><!-- /#our-speakers -->

          </section>
        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->
    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
